var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"proveedores"},[_c('MenuOpcion',{attrs:{"titulo":_vm.titulo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }